import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Select from "react-select";
import axiosInstance from "../../../axiosInterceptor";
import { permissionSchema } from "../../../Validation/Validation";
import { customStyles } from "../../../utils/constant";

const AddPermission = ({
  editData,
  fetchPaginationData,
  setEditData,
  adminId,
  pageOptions,
  setPageOptions,
  pages,
  setPages,
  fetchPages,
}) => {
  const editingId = editData?._id;
  const [loading, setLoading] = useState(false);

  const [permissionOptions, setPermissionOptions] = useState([]);
  const { values, errors, touched, handleSubmit, resetForm, setFieldValue } =
    useFormik({
      initialValues: {
        page: null,
        permission: [],
      },
      validationSchema: permissionSchema,
      enableReinitialize: false,
      onSubmit: async (values) => {
        setLoading(true);
        try {
          const payload = {
            adminId: adminId,
            pageId: values.page.value,
            action: values.permission.map((item) => item.value),
          };
          const response = editingId
            ? await axiosInstance.put(
                `/permission/updatePermission/${editingId}`,
                payload,
              )
            : await axiosInstance.post("/permission/createPermission", payload);
          toast.success(response.data.message);
          resetForm();
          setPermissionOptions([]);
          setEditData(null);
          fetchPaginationData();
          fetchPages();
        } catch (error) {
          toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
          setLoading(false);
        }
      },
    });
 useEffect(() => {
  if (!editingId || !editData) {
    return;
  }

  // Page directly from editData
  setFieldValue("page", {
    value: editData.pageId?._id,
    label: editData.pageId?.pageName,
  });

  // Permission options from editData actions
  const options = (editData.action || []).map((action) => ({
    value: action,
    label: action,
  }));

  setPermissionOptions(options);

  // Selected permissions
  setFieldValue(
    "permission",
    (editData.action || []).map((action) => ({
      value: action,
      label: action,
    }))
  );
}, [editingId, editData, setFieldValue]);
  const handlePageChange = (selected) => {
    setFieldValue("page", selected);
    setFieldValue("permission", []);
    if (!selected) {
      setPermissionOptions([]);
      return;
    }
    const selectedPage = pages.find((item) => item._id === selected.value);
    if (!selectedPage) {
      setPermissionOptions([]);
      return;
    }
    const options = selectedPage.action.map((action) => ({
      value: action,
      label: action,
    }));
    setPermissionOptions(options);
  };

  const handleCancel = () => {
    resetForm();
    setPermissionOptions([]);
    setEditData(null);
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Module</label>
                  <Select
                    options={pageOptions}
                    value={values.page}
                    styles={customStyles}
                    placeholder="Select Module"
                    isClearable
                    onChange={handlePageChange}
                  />

                  {touched.page && errors.page && (
                    <div className="text-danger mt-1">{errors.page}</div>
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Permission</label>

                  <Select
                    isMulti
                    options={permissionOptions}
                    value={values.permission}
                    styles={customStyles}
                    placeholder={
                      values.page ? "Select Permission" : "First Select Module"
                    }
                    isDisabled={!values.page}
                    onChange={(selected) =>
                      setFieldValue("permission", selected || [])
                    }
                  />

                  {touched.permission && errors.permission && (
                    <div className="text-danger mt-1">{errors.permission}</div>
                  )}
                </div>
                <div className="col-12 text-center mt-3">
                  <button
                    className="btn btn-primary mr-2"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : editingId ? "Update" : "Save"}
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPermission;
